<template>
  <div
    class="pg-dialog-input-border"
    @click="showEvent"
    @mouseenter="showCloseIconFun(true)"
    @mouseleave="showCloseIconFun(false)"
  >
    <div class="pg-dialog-input-border__text">
      <PgInput :value="value" @input="onOk" :readonly="readonly" :placeholder="placeholder" />
    </div>
    <span class="pg-dialog-input-border__icon">
      <i
        v-if="showCloseIcon"
        class="el-icon-circle-close"
        style="color: #c0c4cc; margin-right: 3px"
        @click.stop="remove"
      ></i>
      <i :class="[prefixIcon, 'pg-dialog-input-border__icon-serach']" @click.self="showEvent"></i>
    </span>
    <PgInputMain
      v-if="showRander"
      v-bind="$attrs"
      :value="value"
      @on-cancel="onCancel"
      @on-ok="onOk"
      :visible="visible"
      :rows="rows"
      :buttonClose="buttonClose"
      :title="title"
    ></PgInputMain>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import PgInputMain from './main.vue'
import { ref } from 'vue'
import { useDisplay } from '../hook/use-display'

const props = defineProps({
  value: [String],
  multiple: Boolean,
  placeholder: {
    type: String,
    default: '批量输入',
  },
  title: {
    type: String,
    default: '请输入',
  },
  readonly: {
    type: Boolean,
    default: true,
  },
  prefixIcon: {
    type: String,
    default: 'ivu-icon-icon-pg-dingdansucha',
  },
  rows: {
    type: Number,
    default: 8,
  },
  clearable: {
    type: Boolean,
    default: true,
  },
  buttonClose: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['input'])

const { visible, showRander, showEvent, onCancel } = useDisplay(props)

const remove = () => {
  onOk(null)
}
const onOk = (value) => {
  emit('input', value)
}

const showCloseIcon = ref(false)
const showCloseIconFun = (type) => {
  if (!props.clearable) return false

  if (props.value && type) showCloseIcon.value = true
  else showCloseIcon.value = false
}
</script>
<style lang="scss">
@import '../slyle/dialog-input-border.scss';
</style>
